namespace TR {
    class SimpleImageGallery {

        width: number;
        height: number;

        imageNumber: number;
        estabId: number;
        images: string[];
        slider: any;
        directions = { LEFT: 0, RIGHT: 1 };
        size: any;

        touchStart: number;

        constructor(
            private $scope: ng.IScope,
            $element: any,
            private imageService: any
        ) {
            // CSS Setup
            const gallery = $element.find('.simple-image-gallery');
            const leftArrow = gallery.find('.icon-chevron-left');
            const rightArrow = gallery.find('.icon-chevron-right');
            this.slider = gallery.find('.slider');

            const arrowSize = Math.floor(this.height / 8);
            const arrowTop = (this.height / 2) - (arrowSize / 2);
            const arrowCss = {
                'font-size': `${arrowSize}px`,
                'top': `${arrowTop}px`
            };

            gallery.css('height', `${this.height}px`);
            leftArrow.css(arrowCss);
            rightArrow.css(arrowCss);

            $scope.$watch(() => gallery.is(':visible'), () => this._setPadding(gallery));
            $scope.$watch(() => gallery.width(), () => this._setPadding(gallery));

            this.slider.css({
                left: `-${this.width}px`,
            });

            this.size = {
                width: `${this.width}px`,
                height: `${this.height}px`
            };

            // Image Insertion
            this.$scope.$watch('si.estabId', v => {
                if (!v) { return; }
                this.images = [];
                for (let i = 0, ii = this.imageNumber; i < ii; i++) {
                    this.images.push(
                        imageService.getImageUrl(this.estabId, this.width, this.height, i, true)
                    );
                }
            });

            // Events
            rightArrow.click(() => this._slide(this.directions.RIGHT));
            leftArrow.click(() => this._slide(this.directions.LEFT));

            gallery[0].addEventListener('touchstart', e => this._handleTouchStart(e), false);
            gallery[0].addEventListener('touchend', e => this._handleTouchMove(e), false);
        }

        private _setPadding(gallery) {
            const w = gallery.width();
            const pad = w > this.width ? `${(w - this.width) / 2}px` : '10px';

            if (w > this.width) {
                this.slider.css('padding-left', pad);
            }
        }

        private _handleTouchStart(e) {
            this.touchStart = e.touches[0].clientX;
        }

        private _handleTouchMove(e) {
            if (!this.touchStart) { return; }
            const touchEnd = e.changedTouches[0].clientX;
            const diff = this.touchStart - touchEnd;
            if (Math.abs(diff) < 30) { return; }
            return this._slide(diff > 0 ? this.directions.RIGHT : this.directions.LEFT);
        }

        private _slide(dir: number) {
            const current = parseInt(this.slider.css('left'), 10);
            const move = dir === this.directions.LEFT
                ? current + this.width
                : current - this.width;

            this.slider.animate(
                { left: move },
                200,
                () => {
                    const selectedImage = TRPCONFIG.Rtl ? 'img:nth-last-child(2)' : 'img:nth-child(2)';
                    this.slider.find(selectedImage).css('opacity', '0.5');
                    const first = this.slider.find('img:first');
                    const last = this.slider.find('img:last');

                    if ( TRPCONFIG.Rtl ) {
                        if (dir === this.directions.RIGHT) { first.before(last); }
                        else { last.after(first); }
                    } else {
                        if (dir === this.directions.LEFT) { first.before(last); }
                        else { last.after(first); }
                    }
                    this.slider.css({ 'left': `-${this.width}px` });
                    this.slider.find(selectedImage).css('opacity', '1');
                });
        }
    }

    angular
        .module('TR')
        .directive('simpleImageGallery', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=SimpleImageGallery',
                bindToController: {
                    estabId: '=',
                    imageNumber: '=',
                    width: '=?',
                    height: '=?'
                },
                controller: SimpleImageGallery,
                controllerAs: 'si'
            };
        });

}
